module.exports = __webpack_public_path__ + "img/AtaMuhammad-RozhekXani.05ad2815.jpg";